import React from "react";
import styled from "styled-components";


export default styled.a`
    flex: 1 0 52%;
    cursor: pointer;
    text-decoration: none;
    padding: 0 30px 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    color: rgb(106 109 144);
    box-sizing: border-box;

    @media(max-width: 1553px) {
        flex-basis: calc(35% - 70px);
    }

    @media(max-width: 1024px) {
        flex-basis: 100%;
        margin-bottom: 10px;
    }
    .inner {
        flex: 1 0 100%;
        font-size: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 59px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        line-height: 28px;
        text-decoration: none;
        border-left: 4px solid rgb(106 109 144);
        background: rgb(239 240 243);
        padding: 0 30px 0 35px;
    }
`;
